import { CallTrackingDetail } from '@user/features/EntityDetails/components/CallTrackingSection/state'
import Box from '@mui/material/Box'
import { LinkArrowIcon } from '@sales-center/components'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import * as React from 'react'
import type { ReactElement } from 'react'
import { useTheme } from '@mui/material/styles'

type Props = {
  field: CallTrackingDetail
  callTrackingPhone?: string
}

function RecordingField(props: Props) {
  const { field } = props
  const theme = useTheme()
  return (
    <Box mb={3} mr={3}>
      <Typography variant="body2" color={theme.palette.text.secondary}>
        Link to Call Recording
      </Typography>
      {!!field?.fieldValue ? (
        <Button
          size="small"
          variant="text"
          href={field.fieldValue}
          target="_blank"
          data-test-id="callTrackingRecordingButton"
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography color="#1565c0" variant="subtitle2">
              Audio Recording
            </Typography>
            <LinkArrowIcon />
          </Stack>
        </Button>
      ) : (
        <Typography variant="subtitle2" color={theme.palette.text.primary}>
          -
        </Typography>
      )}
    </Box>
  )
}

function FirstCallField(props: Props) {
  const { field, callTrackingPhone } = props
  const theme = useTheme()
  return (
    <Box mb={3} mr={3}>
      <Typography variant="body2" color={theme.palette.text.secondary}>
        {field?.callTrackingSystemFieldName}
      </Typography>
      {!!field.fieldValue ? (
        <Button
          size="small"
          variant="text"
          href={`https://app.calltrackingmetrics.com/calls#filter=caller_number%3A"${callTrackingPhone}"`}
          target="_blank"
          data-test-id="callTrackingFirstCallButton"
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography color="#1565c0" variant="subtitle2">
              {field.fieldValue}
            </Typography>
            <LinkArrowIcon />
          </Stack>
        </Button>
      ) : (
        <Typography variant="subtitle2" color={theme.palette.text.primary}>
          -
        </Typography>
      )}
    </Box>
  )
}

export function CallTrackingField(props: Props): ReactElement | null {
  const { field, callTrackingPhone } = props
  const theme = useTheme()
  // Field with callTrackingSystemFieldId === 8 is field with link to record
  return +field?.callTrackingSystemFieldId === 8 ? (
    <RecordingField field={field} />
  ) : +field?.callTrackingSystemFieldId === 5 ? (
    <FirstCallField field={field} callTrackingPhone={callTrackingPhone} />
  ) : (
    <Box mr={3} mb={3}>
      <Typography variant="body2" color={theme.palette.text.secondary}>
        {field?.callTrackingSystemFieldName}
      </Typography>
      <Typography variant="subtitle2" color={theme.palette.text.primary}>
        {field?.fieldValue || '-'}
      </Typography>
    </Box>
  )
}
